module.exports = __webpack_public_path__ + "static/ipad-iphone-1bfb0bd4fdad48e7e86fe629b5fd1af5.png";